<div>
  <form [formGroup]="countryWiseServiceRequirementForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>

        <!-- Header Fields -->
        <div class="cwsr-header-fields">

          <mat-form-field appearance="fill">
            <mat-label>Country</mat-label>
            <mat-select formControlName="countryId" required
              [matTooltip]="getSelectedName(countries, countryId.value)"
              matTooltipPosition="above">
              <mat-option>
                <ngx-mat-select-search [searching]="searching" [formControl]="countrySearchCtrl"
                  noEntriesFoundLabel="no matching found" placeholderLabel="Find Country">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option [value]="null">None</mat-option>
              @for (c of filteredCountries | async; track c) {
                <mat-option [value]="c.id"
                  [matTooltip]="c.name" matTooltipPosition="right">
                  {{ c.name }}
                </mat-option>
              }
            </mat-select>
            @if (countryId.touched && countryId.invalid && countryId.hasError('required')) {
              <mat-error>
                Country is Required
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Business Segment</mat-label>
            <mat-select formControlName="businessSegmentId" required
              [matTooltip]="getSelectedName(businessSegments, businessSegmentId.value)"
              matTooltipPosition="above">
              <mat-option>
                <ngx-mat-select-search [searching]="searching" [formControl]="bsSearchCtrl"
                  noEntriesFoundLabel="no matching found" placeholderLabel="Find Business Segment">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option [value]="null">None</mat-option>
              @for (bs of filteredBusinessSegments | async; track bs) {
                <mat-option [value]="bs.id"
                  [matTooltip]="bs.name" matTooltipPosition="right">
                  {{ bs.name }}
                </mat-option>
              }
            </mat-select>
            @if (businessSegmentId.touched && businessSegmentId.invalid && businessSegmentId.hasError('required')) {
              <mat-error>
                Business Segment is Required
              </mat-error>
            }
          </mat-form-field>

        </div>

        <!-- Add Row Button — right aligned -->
        @if (!disableSubmit) {
          <div class="cwsr-add-row">
            <a class="__add_client" (click)="addRow()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Add Row
            </a>
          </div>
        }

        <!-- Detail Table -->
        <table class="cwsr-table">
          <thead>
            <tr>
              <th>Service Requirements *</th>
              <th>Created By</th>
              <th>Date &amp; Time</th>
              <th class="toggle-col">Not Required</th>
              <th class="action-col">Action</th>
            </tr>
          </thead>
          <tbody formArrayName="countryWiseServiceRequirementDetails">
            @for (entry of detailEntries; track trackByEntry($index, entry)) {
              <tr [formGroupName]="entry.index"
                [class.duplicate-row]="duplicateServiceIndices.has(entry.index)">
                <!-- Service Requirements -->
                <td>
                  <mat-form-field appearance="fill" style="width:100%;">
                    <mat-select formControlName="serviceId" placeholder="Select Service"
                      [matTooltip]="getSelectedServiceDescription(entry.control.get('serviceId').value)"
                      matTooltipPosition="above"
                      (selectionChange)="checkDuplicateServices()">
                      <mat-option>
                        <ngx-mat-select-search [searching]="searching"
                          [formControl]="serviceSearchCtrl"
                          noEntriesFoundLabel="no matching found"
                          placeholderLabel="Find Service">
                          <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option [value]="null">None</mat-option>
                      @for (s of filteredServices | async; track s) {
                        <mat-option [value]="s.id"
                          [style.display]="s._hidden ? 'none' : ''"
                          [matTooltip]="s.serviceDescription"
                          matTooltipPosition="right">
                          {{ s.serviceDescription }}
                        </mat-option>
                      }
                    </mat-select>
                    @if (entry.control.get('serviceId').touched && entry.control.get('serviceId').hasError('required')) {
                      <mat-error>
                        Service is Required
                      </mat-error>
                    }
                  </mat-form-field>
                  @if (duplicateServiceIndices.has(entry.index)) {
                    <span
                    style="color:red; font-size:11px;">Duplicate service</span>
                  }
                </td>
                <!-- Created By -->
                <td class="audit-cell">
                  {{ entry.control.get('displayCreatedBy')?.value || '' }}
                </td>
                <!-- Date & Time -->
                <td class="audit-cell">
                  {{ entry.control.get('displayCreatedDate')?.value || '' }}
                </td>
                <!-- Not Required toggle with Yes / No label -->
                <td class="toggle-col">
                  <div class="toggle-wrapper">
                    <span class="toggle-label"
                      [style.color]="entry.control.get('notRequired').value ? '#1976d2' : '#9e9e9e'">
                      {{ entry.control.get('notRequired').value ? 'Yes' : 'No' }}
                    </span>
                    <mat-slide-toggle formControlName="notRequired"></mat-slide-toggle>
                  </div>
                </td>
                <!-- Action: add mode — all rows (>1); edit mode — only new rows (no id) -->
                <td class="action-col">
                  @if (!disableSubmit && (id.value ? !entry.control.get('id')?.value : details.length > 1)) {
                    <span
                      (click)="removeRow(entry.index)">
                      <mat-icon class="delete-icon">delete</mat-icon>
                    </span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>

        <!-- Save / Cancel — right aligned, project-standard -->
        <mat-card-actions class="cwsr-actions">
          <button type="button" mat-button color="primary"
            [disabled]="!getSaveBtnCondition()"
          (click)="onSave()">SAVE</button>
          <button type="button" mat-button color="cancel"
          (click)="onCancel()">CANCEL</button>
        </mat-card-actions>

        <!-- View Log -->
        @if (id.value) {
          <div class="audit-log">
            <button mat-stroked-button type="button" [class.active]="viewLog.value"
                (click)="viewLog.setValue(!viewLog.value)">
                <mat-icon>history</mat-icon> View Log
            </button>
          </div>
        }
        @if (viewLog.value) {
          <app-history [referenceType]="'COUNTRY_WISE_SERVICE_REQUIREMENT'" [referenceId]="id.value"></app-history>
        }

      </mat-card-content>
    </mat-card>
  </form>
</div>
